/** The contexts the builder's parts read: the change format (percent / absolute) and the roll-up. */

import type { ReactNode } from 'react';

import { ChangeFormatContext, changeFormatOf } from './change-format.ts';
import { RollupContext, type RollupState } from './rollup-context.ts';
import type { CompareSetting } from './reports-api.ts';

export function BuilderScope(props: {
  compare: CompareSetting | undefined;
  rollup: RollupState | null;
  children: ReactNode;
}): ReactNode {
  return (
    <ChangeFormatContext.Provider value={changeFormatOf(props.compare)}>
      <RollupContext.Provider value={props.rollup}>{props.children}</RollupContext.Provider>
    </ChangeFormatContext.Provider>
  );
}
